import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { default as ConfirmationModal } from '../../Popup/ConfirmationModal';
import { useTranslation } from 'react-i18next';
import { PremiumTrash, Lock, Unlock } from '@wix/da-ds/pkg/Icons/Confirmations';
export const CommissionConfirmation = ({ isOpen =false , confirmationType , onConfirm , onCancel  })=>{
    const { t  } = useTranslation();
    const content = {
        remove: {
            title: t('commission.delete.confirmHeader'),
            text: t('commission.delete.confirmText'),
            confirmBtnLabel: t('commission.delete.confirmButton'),
            confirmBtnType: 'danger',
            icon: /*#__PURE__*/ React.createElement(PremiumTrash, null)
        },
        enable: {
            title: t('commission.enable.confirmHeader'),
            text: t('commission.enable.confirmText'),
            confirmBtnLabel: t('commission.enable.confirmButton'),
            icon: /*#__PURE__*/ React.createElement(Unlock, null)
        },
        enableAll: {
            title: t('commission.enableAll.confirmHeader'),
            text: t('commission.enableAll.confirmText'),
            confirmBtnLabel: t('commission.enableAll.confirmButton'),
            icon: /*#__PURE__*/ React.createElement(Unlock, null)
        },
        disable: {
            title: t('commission.disable.confirmHeader'),
            text: t('commission.disable.confirmText'),
            confirmBtnLabel: t('commission.disable.confirmButton'),
            confirmBtnType: 'danger',
            icon: /*#__PURE__*/ React.createElement(Lock, null)
        },
        disableAll: {
            title: t('commission.disableAll.confirmHeader'),
            text: t('commission.disableAll.confirmText'),
            confirmBtnLabel: t('commission.disableAll.confirmButton'),
            confirmBtnType: 'danger',
            icon: /*#__PURE__*/ React.createElement(Lock, null)
        },
        disableLast: {
            title: t('commission.disableLast.confirmHeader'),
            text: t('commission.disableLast.confirmText'),
            confirmBtnLabel: t('commission.disableLast.confirmButton'),
            confirmBtnType: 'danger',
            icon: /*#__PURE__*/ React.createElement(Lock, null)
        },
        discardChanges: {
            title: t('commission.confirm.discardChanges.header'),
            text: t('commission.confirm.discardChanges.text'),
            confirmBtnLabel: t('popup.discardChanges'),
            confirmBtnType: 'danger',
            icon: /*#__PURE__*/ React.createElement(PremiumTrash, null)
        },
        leaveCreating: {
            title: t('commission.confirm.discard.header'),
            text: t('commission.confirm.discard.text'),
            confirmBtnLabel: t('popup.discard'),
            confirmBtnType: 'danger',
            icon: /*#__PURE__*/ React.createElement(PremiumTrash, null)
        }
    };
    return /*#__PURE__*/ React.createElement(ConfirmationModal, _extends({}, content[confirmationType], {
        onCancel: onCancel,
        onConfirm: onConfirm,
        isOpen: isOpen
    }));
};
CommissionConfirmation.displayName = 'CommissionConfirmation';
export default CommissionConfirmation;
